import time from './time';
import common from './common';
import localStorageHandler from './localStorageHandler';
import sessionStorageHandler from './sessionStorageHandler';
import sessionPersistanceHandler from './sessionPersistanceHandler';

export default {
  ...time,
  ...common,
  ...localStorageHandler,
  ...sessionStorageHandler,
  ...sessionPersistanceHandler,
};
